import { graphql, PageProps } from 'gatsby';
import React, { ReactElement } from 'react';
import Layout from 'src/elements/layout/layout';
import Investors from 'src/molecules/investors/investors';
import BannerLanding from 'src/organisms/banners/banner.about';
import Founders from 'src/organisms/founders/founders';
import OurStory from 'src/organisms/ourStory/ourStory'
import PassionateAboutIndependence from 'src/organisms/passionateAboutIndependence/passionateAboutIndependence';
import OurTeamPurpleSection from 'src/organisms/ourTeam/ourTeam.purple';
import MightyNetworksNews from 'src/organisms/mightyNetworksNews/mightyNetworksNews';

export const ABOUT_PAGE_ID = 'about-page';

interface AboutPageProps extends PageProps{
  data: {
    seoImage?: {
      file?: {
        url: string;
      };
    }
  }
}

const AboutPage = ({ location, data }: AboutPageProps): ReactElement => {
  const helmetData = {
    title: `About Us | Mighty Networks`,
    description: `Mighty Networks unlocks a new era of independent communities mastering something together. Learn why we are passionate about creator independence and empowering every creator with their own Mighty Network Effect.`,
    previewImageURL: data.seoImage?.file?.url
  }

  return (
    <Layout currentPageId={ABOUT_PAGE_ID} helmet={helmetData} location={location}>
      <BannerLanding
        title={`We’re ushering in a world where millions of unique, vibrant communities thrive`}
        description={`Mighty Networks unlocks a new era of independent communities creating and mastering something interesting or important together.`}
      />
      <OurStory />
      <PassionateAboutIndependence />
      <Founders />
      <MightyNetworksNews />
      <Investors />
      <OurTeamPurpleSection />
    </Layout>
  )
}

export const pageQuery = graphql`
  query AboutPageQuery {
    seoImage: contentfulAsset(contentful_id: {eq: "55YFefmkTF6NDYyVuH9yYX"}) {
      file {
        url
      }
    }
  }
`;

export default AboutPage;
